<template>
  <v-card v-if="vehicle">
    <v-btn color="grey" small class="tariff-left-headers">
      <h3>{{ $i18n.t("Service Details") }}</h3>
    </v-btn>
    <z-expense-create
      color="blue"
      style="float: right;"
      x-small
      :accountCode="'VehicleExpense'"
      :entity_id="vehicle._id"
      :expenseType="'Maintenance'"
      @reload="reloadInsurExpenses"
      btn
    >
      <v-btn color="cyan" x-small class="tariff-right-headers">
      +  {{ $i18n.t("Add") }}
      </v-btn>
    </z-expense-create>
    <!-- <v-btn
      color="blue"
      style="float: right"
      x-small
      class="tariff-right-headers"
      target="_blank"
      :href="
        '/expense/create?accountCode=VehicleExpense&expenseType=Maintenance&vehicle_id=' +
        vehicle._id
      "
      >+ {{ $i18n.t("Add") }}</v-btn
    > -->
    <v-row style="padding: 10px 10px">
      <v-col cols="12" sm="6" md="4" lg="4"
        >{{ $i18n.t("Service Type") }} :
        {{ vehicle.vehicleDetail.service.serviceType }}</v-col
      >

      <v-col cols="12" sm="6" md="4" lg="4"
        >{{ $i18n.t("Service Sr No") }} :
        {{ vehicle.vehicleDetail.service.srNo }}</v-col
      >

      <v-col cols="12" sm="6" md="4" lg="4"
        >{{ $i18n.t("Service At KM") }} :
        {{ vehicle.vehicleDetail.service.atKM }}</v-col
      >

      <v-col cols="12" sm="4" md="4" lg="4">
        {{ $i18n.t("Service Status") }} :
        <span v-if="vehicle.vehicleDetail.service.status == 1">Upcoming</span>
        <span v-if="vehicle.vehicleDetail.service.status == 2"
          >In Progress</span
        >
        <span v-if="vehicle.vehicleDetail.service.status == 3">Completed</span>
      </v-col>

      <v-col cols="12" sm="6" md="4" lg="4"
        >{{ $i18n.t("Service Start Date") }} :
        {{ formatDate(vehicle.vehicleDetail.service.startDate) }}</v-col
      >

      <v-col cols="12" sm="6" md="4" lg="4"
        >{{ $i18n.t("Service End Date") }} :
        {{ formatDate(vehicle.vehicleDetail.service.endDate) }}</v-col
      >

      <v-col cols="12" sm="6" md="4" lg="4"
        >{{ $i18n.t("Next Service At KMs") }} :
        {{ vehicle.vehicleDetail.service.nextAtKMs }}</v-col
      >

      <v-col cols="12" sm="6" md="4" lg="4"
        >{{ $i18n.t("Next Service Date") }} :
        {{ formatDate(vehicle.vehicleDetail.service.nextDate) }}</v-col
      >

      <v-col cols="12" sm="6" md="4" lg="4"
        >{{ $i18n.t("Amount") }} : {{ vehicle.vehicleDetail.service.currency }}
        {{ vehicle.vehicleDetail.service.amount }}</v-col
      >

      <v-col cols="12" sm="12" md="6" lg="6"
        >{{ $i18n.t("Servicing Company") }} :
        {{ vehicle.vehicleDetail.service.servicingCompany }}</v-col
      >

      <v-col cols="12" sm="11" md="11" lg="11"
        >{{ $i18n.t("Servicing Description") }} :
        {{ vehicle.vehicleDetail.service.serviceDescription }}</v-col
      >

      <v-col cols="12" sm="1" md="1" lg="1">
        <!-- <a
          v-if="vehicle.vehicleDetail.service.expense_id"
          :href="'/expense/' + vehicle.vehicleDetail.service.expense_id"
          target="_blank"
        >
          <v-icon>mdi-pencil</v-icon>
        </a> -->

        <z-expense-create
          v-if="vehicle.vehicleDetail.service.expense_id"
          color="blue"
          x-small
          :expenseEdit_id="vehicle.vehicleDetail.service.expense_id"
          @reload="reloadInsurExpenses"
          btn
        >
          <v-btn color="cyan" text fab x-small>
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </z-expense-create>
      </v-col>
    </v-row>

    <expenses :expenseType="'Service'" :entity_id="vehicle._id" />
  </v-card>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
// import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import Expenses from "@/views/vehicle/Expenses.vue";

@Component({
  name: "Service",
  props: {
    value: {
      default: null,
    },
  },
  components: {
    Expenses,
  },
})
export default class Service extends Vue {
  vehicle = null;

  get loading() {
    return common.loading;
  }

  async mounted() {
    if (this.value) this.vehicle = this.value;

    if (!this.vehicle) this.vehicle = {};
    if (!this.vehicle.vehicleDetail) this.vehicle.vehicleDetail = {};
    if (!this.vehicle.vehicleDetail.service)
      this.vehicle.vehicleDetail.service = {};
  }

  @Watch("value")
  onValueChange(newVal) {
    this.vehicle = newVal;
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }

  reloadInsurExpenses() {
    this.$root.$emit('reloadExpenses', true);
    // this.$emit("reload", true);
  }
}
</script>

<style scoped>
.tariff-left-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  left: 10px;
  right: 0px;
  font-size: 12px;
}
.tariff-right-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  right: 10px;
  font-size: 12px;
}
.close-button {
  text-transform: none;
  color: rgb(255, 66, 66);
  bottom: 7px;
  /* top: -10px; */
  right: 0px;
  font-size: 12px;
  position: absolute;
  z-index: 100;
}
.tab-pane {
  display: none;
}
</style>